import request from '../request'

//发送验证码接口
export function sendSms(params) {
  return request({ url: '/api/MemberUser/sendSms',method: 'post',data: params})
}
//手机号+验证码登录
export function loginCode(params) {
  return request({ url: '/api/MemberUser/loginCode',method: 'post',data: params})
}
//账号密码登录
export function login(params) {
  return request({ url: '/api/MemberUser/login',method: 'post',data: params})
}
//获取个人信息
export function detail(params) {
  return request({ url: '/api/MemberUser/detail',method: 'post',data: params})
}
//忘记密码
export function updatePassword(params) {
  return request({ url: '/api/MemberUser/updatePassword',method: 'post',data: params})
}
//判断是否为登录状态和会员
export function is_vip_login(params) {
  return request({ url: '/api/MemberUser/is_vip_login',method: 'post',data: params})
}




// WEBPACK FOOTER //
// ./src/api/gw/login.js